import React, { useState, useEffect } from "react";
import { FiClock } from "react-icons/fi"; // Assuming you use react-icons

const SessionTimer = ({ loginTime, onExpire }) => {
  // Configurable durations
  const SESSION_DURATION_MINS = 60;
  const WARNING_THRESHOLD_MINS = 10;

  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    // If no login time is provided, don't run the timer
    if (!loginTime) return;

    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const loginTimestamp = new Date(loginTime).getTime();
      const expiryTimestamp =
        loginTimestamp + SESSION_DURATION_MINS * 60 * 1000;
      const difference = expiryTimestamp - now;
      return Math.max(0, Math.floor(difference / 1000)); // Return seconds
    };
    // Initial calculation
    setTimeLeft(calculateTimeLeft());

    // Update every second
    const timer = setInterval(() => {
      const remainingSeconds = calculateTimeLeft();
      setTimeLeft(remainingSeconds);

      if (remainingSeconds <= 0) {
        clearInterval(timer);
        if (onExpire) onExpire(); // Trigger logout function when it hits 0
      }
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [loginTime, onExpire]);

  // Don't render anything until we have calculated the time
  if (timeLeft === null) return null;

  // Formatting minutes and seconds
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  // Check if we are in the warning zone (10 mins or less)
  const isWarningZone = minutes < WARNING_THRESHOLD_MINS;

  return (
    <div
      className={`d-flex align-items-center gap-2 px-3 py-1 rounded-pill ${
        isWarningZone ? "bg-danger-subtle text-danger" : "bg-light text-muted"
      }`}
      style={{
        border: isWarningZone ? "1px solid #f87171" : "1px solid #e2e8f0",
        fontWeight: "600",
        fontSize: "13px",
        transition: "all 0.3s ease",
      }}
    >
      <FiClock className={isWarningZone ? "animate-pulse" : ""} />
      <span>{timeLeft > 0 ? formattedTime : "Expired"}</span>
    </div>
  );
};

export default SessionTimer;
